<mat-card>
  <h2 translate>Prueba desarrollo Ekip</h2>
  <mat-card-content>
    <form [formGroup]="ThirdPartySamlForm" (ngSubmit)="showIframeLogalty()">
      <div class="container-form">
        <div class="subcontainer">
          <mat-label>Trama SAML</mat-label>
          <mat-form-field appearance="outline">
            <textarea formControlName="saml" matInput placeholder="Introduce trama SAML"></textarea>
          </mat-form-field>
        </div>
      </div>
      <div class="button">
        <button class="btn" type="submit" mat-raised-button color="primary" [disabled]="ThirdPartySamlForm.invalid">
          Cargar
        </button>
      </div>
    </form>
  </mat-card-content>
</mat-card>
